module.exports = __webpack_public_path__ + "img/1540463470.178a7608.jpg";